var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 61,
    viewBox: "0 0 68 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder",
    clipPath: "url(#clip0_4878_14546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M67.1667 53.7786C67.1667 55.5468 66.4643 57.2425 65.2141 58.4927C63.9638 59.7429 62.2681 60.4453 60.5 60.4453H7.16667C5.39856 60.4453 3.70286 59.7429 2.45262 58.4927C1.20238 57.2425 0.5 55.5468 0.5 53.7786V7.11198C0.5 5.34387 1.20238 3.64818 2.45262 2.39793C3.70286 1.14769 5.39856 0.445313 7.16667 0.445312H23.8333L30.5 10.4453H60.5C62.2681 10.4453 63.9638 11.1477 65.2141 12.3979C66.4643 13.6482 67.1667 15.3439 67.1667 17.112V53.7786Z",
    fill: "#9FC1EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4878_14546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 60,
    fill: "white",
    transform: "translate(0.5 0.445312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.28ac73b32f28939f789bb5fffc936598.svg";
export { ForwardRef as ReactComponent };